import { Component, OnInit, Optional, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContactCenterApiService } from '../../../v2/apis/contact-center/contact-center-api.service';
import { ToastrService } from 'ngx-toastr';
import { ChatService } from '../../../service/chat-service';
import { KeyVaultService } from '../../../service/key-vault.service';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { PlatformRegionService } from '../../../service/shared/platform-region.service';

export interface RequestDetailData {
  id: number;
  request_number: string;
  customer_name: string;
  subject: string;
  attachments?: Attachment[];
  status?: string;
  assigned_to?: string;
  created_date?: Date;
  updated_date?: Date;
  request_type: string;
  requested_by_name?: string;
}

export interface Attachment {
  id: number;
  name: string;
  // url: string;
}

@Component({
    selector: 'app-details-description',
    templateUrl: './details-description.component.html',
    styleUrl: './details-description.component.scss',
    standalone: false
})
export class DetailsDescriptionComponent implements OnInit {
  data: RequestDetailData | null = null;
  requestId: number;
  attachments: Attachment[] = [];
  isLoading: boolean = false;
  apimUrl: any;
  dialog: any;

  constructor(
    @Optional() private route: ActivatedRoute,
    @Optional() private router: Router,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: RequestDetailData,
    @Optional() public dialogRef: MatDialogRef<DetailsDescriptionComponent>,
    private contactCenterService: ContactCenterApiService,
    private toastr: ToastrService, public ChatService: ChatService, private readonly keyVaultService: KeyVaultService,
    private platformRegionService: PlatformRegionService
  ) { }

  ngOnInit(): void {
    if (this.dialogData) {
      this.requestId = this.dialogData.id;
      this.loadRequestDetails();
    } else if (this.route) {
      this.requestId = Number(this.route.snapshot.paramMap.get('id'));
      this.loadRequestDetails();
    }
    this.keyVaultService.apimUrl$.pipe(take(1)).subscribe(url => this.apimUrl = url);
  }

  loadRequestDetails(): void {
    this.isLoading = true;
    this.contactCenterService.getRequestWithLogs(this.requestId).subscribe({
      next: (response) => {
        this.data = {
          id: response.request.id,
          request_number: `${response.request.id}`,
          customer_name: `${response.request.given_by}`,
          subject: response.request.user_request,
          status: response.request.status,
          assigned_to: '',
          created_date: new Date(response.request.created_date),
          updated_date: new Date(response.request.updated_date),
          request_type: response.request.request_type,
          requested_by_name: `${response.request.requested_by_first_name || ''} ${response.request.requested_by_last_name || ''}`.trim() || ''
        };

        if (response.request.attachment) {
          this.attachments = [{
            id: 1,
            name: response.request.attachment,
            // url:  this.getAttachmentUrl(response.request.attachment),
          }];
        } else {
          this.attachments = [];
        }

        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading request details:', error);
        this.toastr.error('Failed to load request details.');
        this.isLoading = false;
      }
    });
  }



  viewAttachment(attachment: Attachment): void {
    window.open('', '_blank');
  }
  downloadContactCenterImage(event, imageFileName: string): void {
    event?.stopPropagation?.();
    event?.preventDefault?.();
    if (!imageFileName) {
      this.toastr.error('Image is not available');
      return;
    }
    if (!this.apimUrl) {
      this.toastr.error('Unable to load image. Please try again.');
      return;
    }
    const JWT_token = localStorage.getItem('bearer_token');
    const requestType = this.data?.request_type === 'Bugs' ? 'Bugs' : 'Enhancements';
    const blobPath = `${requestType}/${imageFileName}`;
    const docUrl = `${this.apimUrl}/ai-advisor-storage/getblobmetadata?blobContainer=aiadvisor-contact-center&fileNameWithExtension=${blobPath}&Authorization=${JWT_token}`;
    const ext = imageFileName.split('.').pop()?.toLowerCase();
    const mimeType = ext === 'pdf' ? 'application/pdf' : ext === 'png' ? 'image/png' : ext === 'jpg' || ext === 'jpeg' ? 'image/jpeg' : 'application/octet-stream';
    this.ChatService.getPdfReport(docUrl, mimeType).subscribe(res => {
      const fileURL = URL.createObjectURL(res);
      const newTab = window.open(fileURL, '_blank');
      if (!newTab) {
        this.dialog.open(ConfirmationDialogComponent, {
          width: '400px',
          data: { message: 'Please ensure your browser is not blocking any popup', okOnly: true },
          autoFocus: false
        });
      }
    },
      (err) => {
        this.toastr.error('An error occurred while extracting the image... Please try again.', '', { positionClass: 'toast-top-right' });
      });
  }
  onClose(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
